import { useEffect, useRef } from 'react';
import { useCompleteExternalConnectionAuthMutation } from 'shared/hooks/queries/use-complete-external-connection-auth-mutation';
import { QueryParamOptions, useQueryParams } from 'shared/lib/react-router-dom';
import { getErrorReporter } from 'shared/services/error-tracking';

// Claims from wherever the user lands: logging in on the way back drops them on their own screen.
export const useClaimExternalConnection = () => {
  const [
    { [QueryParamOptions.ConnectionToken]: connectionToken },
    setConnectionTokenParam,
  ] = useQueryParams([QueryParamOptions.ConnectionToken]);
  const { mutateAsync } = useCompleteExternalConnectionAuthMutation();
  const claiming = useRef(false);

  useEffect(() => {
    if (!connectionToken || claiming.current) {
      return;
    }
    claiming.current = true;

    // Single-use server-side, so a retry could only ever fail — take it out of the url first.
    setConnectionTokenParam();

    mutateAsync(connectionToken).catch((error) => {
      getErrorReporter().captureException(error, {
        tags: { source: 'claim-external-connection' },
      });
    });
  }, [connectionToken, mutateAsync, setConnectionTokenParam]);
};
